import { CodeSystem, ElasticsearchConfig } from "../types";

const environment = import.meta.env.VITE_ENVIRONMENT; // dev, stage, prod

const config: ElasticsearchConfig = {
  configVersion: 1,
  codeSystem: CodeSystem.Adm,
  indexName: `search-ehelse-kodeverk-${environment}-kis`,
  minimumScore: 0,
  minimumNestedFieldScore: 60,
  maximumNestedFieldValues: 5,
  displayScore: true,
  properties: [
    {
      propertyName: "code_system_oid",
      displayName: "Kodeverk ID",
      weight: 1,
      searchEnabled: true,
      returnInResults: true
    },
    {
      propertyName: "name_norwegian",
      displayName: "Kodeverkstittel",
      weight: 3,
      searchEnabled: true,
      returnInResults: true
    },
    {
      propertyName: "description",
      weight: 2,
      searchEnabled: true,
      returnInResults: true,
      displayName: "Beskrivelse"
    },
    {
      propertyName: "owner_name",
      weight: 1,
      searchEnabled: true,
      returnInResults: true,
      displayName: "Eier"
    },
    {
      propertyName: "collection_name",
      weight: 1,
      searchEnabled: true,
      returnInResults: true,
      displayName: "Samling"
    },
    {
      propertyName: "category_name",
      weight: 1,
      searchEnabled: true,
      returnInResults: true,
      displayName: "Kategori"
    },
    {
      propertyName: "valid_from",
      weight: 1,
      searchEnabled: false,
      returnInResults: true,
      displayName: "Gyldig fra"
    },
    {
      propertyName: "valid_to",
      weight: 1,
      searchEnabled: false,
      returnInResults: true,
      displayName: "Gyldig til"
    },
    {
      propertyName: "status_text",
      weight: 1,
      searchEnabled: false,
      returnInResults: true,
      displayName: "Statustekst"
    },
    {
      propertyName: "active",
      weight: 1,
      searchEnabled: false,
      returnInResults: false,
      displayName: "Aktiv"
    },
    {
      propertyName: "status_changed_date",
      weight: 1,
      searchEnabled: false,
      returnInResults: false,
      displayName: "Opprettet dato"
    },
    {
      propertyName: "internal_id",
      weight: 1,
      searchEnabled: false,
      returnInResults: false,
      displayName: ""
    }
  ],
  nestedProperties: [
    {
      propertyName: "codes",
      weight: 1,
      searchEnabled: true,
      returnInResults: true,
      nestedFields: [
        {
          propertyName: "name_norwegian",
          weight: 3,
          searchEnabled: true,
          returnInResults: true,
          displayName: "Kodetekst"
        },
        {
          propertyName: "code",
          weight: 3,
          searchEnabled: true,
          returnInResults: true,
          displayName: "Kodeverdi"
        },
        {
          propertyName: "description",
          weight: 2,
          searchEnabled: true,
          returnInResults: true,
          displayName: "Kodeforklaring"
        },
        {
          propertyName: "active",
          weight: 1,
          searchEnabled: false,
          returnInResults: true,
          displayName: "Aktiv"
        },
        {
          propertyName: "valid_from",
          weight: 1,
          searchEnabled: false,
          returnInResults: false,
          displayName: "Gyldig fra"
        },
        {
          propertyName: "valid_to",
          weight: 1,
          searchEnabled: false,
          returnInResults: false,
          displayName: "Gyldig til"
        }
      ],
      displayName: "Koder"
    }
  ],
  facetFields: ["status_text", "owner_name"]
};

export default config;
